import { LazyLibURL } from '@shared-features/enums';

export class SentryConstant {
  static IgnoredErrors = [
    /ChunkLoadError/,
    /Non-Error/,
    /NG04002/,
    // Firebase Messaging registers the browser while it is offline and leaves the
    // rejected promise unhandled; our own getToken error handler already covers it.
    /installations\/app-offline/,
    // `idb` (bundled by Firebase) rejecting when the browser aborts an IndexedDB
    // transaction, e.g. low storage or the tab closing mid-write.
    /AbortError: AbortError/,
    // A fetch cancelled by its own timeout inside third-party SDKs (Amplitude);
    // the app itself never aborts requests.
    /signal is aborted without reason/,
  ]
  static DeniedUrls = [
    ...Object.values(LazyLibURL),
    /localhost/,
    /https:\/\/static\.zdassets\.com\//,
    /https?:\/\/((maps|cdn|www)\.)?googleapis\.com/,
    // LinkedIn Insight Tag (third-party marketing analytics) — its fetch calls
    // get blocked by user ad-blockers/extensions and surface as unhandled
    // "Failed to fetch" errors unrelated to our app code.
    /li\.lms-analytics/,
  ]
  /**
   * Scripts whose errors are dropped when they appear anywhere in the stack.
   * `denyUrls` only checks the top frame, and FullStory wraps `fetch`, so its
   * frame sits on top of the LinkedIn one and lets those errors through.
   */
  static DeniedStackUrls = [/li\.lms-analytics/]
}
